import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBa2DzCTOuZ7-1PaCZA-RIxwRVrPi8C5Ns",
  authDomain: "chat-appbyabhi.firebaseapp.com",
  databaseURL: "https://chat-appbyabhi.firebaseio.com",
  projectId: "chat-appbyabhi",
  storageBucket: "chat-appbyabhi.appspot.com",
  messagingSenderId: "627324261090",
  appId: "1:627324261090:web:85fd1b748248f2338c44bb",
  measurementId: "G-BJ4SSN7VWQ",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export default db;
export { provider, auth };
